module.exports = __webpack_public_path__ + "static/img/bg-cscenter-safebilling.80ec5fd4.jpg";